import formatNumber from "./formatNumber";

const formatTipShort = (amount) => {
  if (amount % 1000 === 0) {
    return `${amount / 1000}k`;
  }
  return `${formatNumber(amount)}đ`;
};

export default formatTipShort;
